<template>
<div id="vend">
    <bar-manut 
        single-entity="Vendedor" 
        plural-entity="Vendedores" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <div class="default-container">
        <div class="row">
            <form-field v-model="vend.codvend" :metadata="metadata.vend.codvend" type="text" col="2" :disabled="true"></form-field>
            <form-field ref="nome" v-model="vend.nome" type="text" col="4" :metadata="metadata.vend.nome" 
                name="nome" :v-errors="errors" v-validate="metadata.vend.nome.validator"></form-field>
            <form-field v-model="vend.stvend" type="select" col="2" :metadata="metadata.vend.stvend"></form-field>
            <form-field v-model="vend.cnpj" type="cnpj" col="2" :metadata="metadata.vend.cnpj" 
                name="cnpj" :v-errors="errors" v-validate="metadata.vend.cnpj.validator"></form-field>
            <form-field v-model="vend.cpf" type="number" col="2" :metadata="metadata.vend.cpf" 
                name="cpf" :v-errors="errors" v-validate="metadata.vend.cpf.validator"></form-field>
        </div>
        <div class="row">
            <form-field v-model="vend.cep" type="cep" col="2" :metadata="metadata.vend.cep" 
                name="cep" :v-errors="errors" v-validate="metadata.vend.cep.validator" @update="updateCep"></form-field>
            <form-field v-model="vend.ende" type="text" col="4" :metadata="metadata.vend.ende" 
                name="ende" :v-errors="errors" v-validate="metadata.vend.ende.validator"></form-field>
            <form-field v-model="vend.endenr" type="text" col="2" :metadata="metadata.vend.endenr" 
                name="endenr" :v-errors="errors" v-validate="metadata.vend.endenr.validator"></form-field>
            <form-field v-model="vend.endecomp" type="text" col="4" :metadata="metadata.vend.endecomp" 
                name="endecomp" :v-errors="errors" v-validate="metadata.vend.endecomp.validator"></form-field>
            <form-field v-model="vend.uf" type="select2" col="3" :metadata="metadata.vend.uf"
                name="uf" :v-errors="errors" v-validate="metadata.vend.uf.validator"
                parent="vend"></form-field>
            <form-field v-model="vend.codmun" type="select2" col="3" :metadata="metadata.vend.codmun"
                name="codmun" :v-errors="errors" v-validate="metadata.vend.codmun.validator"
                :select2="{entity: 'mun/uf/' + vend.uf, minlength: 2}"
                parent="vend"></form-field>
            <form-field v-model="vend.fone1" type="fone" col="2" :metadata="metadata.vend.fone1" 
                name="fone1" :v-errors="errors" v-validate="metadata.vend.fone1.validator"></form-field>
            <form-field v-model="vend.fone2" type="fone" col="2" :metadata="metadata.vend.fone2" 
                name="fone2" :v-errors="errors" v-validate="metadata.vend.fone2.validator"></form-field>
            <form-field v-model="vend.fone3" type="fone" col="2" :metadata="metadata.vend.fone3" 
                name="fone3" :v-errors="errors" v-validate="metadata.vend.fone3.validator"></form-field>
            <form-field v-model="vend.email" type="email" col="6" :metadata="metadata.vend.email" 
                name="email" :v-errors="errors" v-validate="metadata.vend.email.validator"></form-field>
        </div>
    </div>

</div>

</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            vend: {...this.$store.getters.getEntities.vend},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.vend.codvend)
        },

        updateCep () {
            //CARREGA INFORMACOES DO CEP
            this.vend.ende = SysVars.endereco.logradouro
            this.vend.bairro = SysVars.endereco.bairro
            this.vend.codmun = SysVars.endereco.ibge
            this.vend.uf = SysVars.endereco.uf
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadVend', { id: this.index } )
            if (this.$store.getters.getVend) {
                this.vend = {...this.$store.getters.getVend}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/vend/' + this.vend.codvend

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/vend/'
            var sendData = {}

            sendData = { vend: this.vend }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {


    },

    created () {
        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
            this.stvend = 'A'
            this.uf = 'SP'
        } else {
            this.loadData()  
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.nome.focus()
        })
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/vend-form.vue